import { Dropdown } from "react-bootstrap";

import {
	faCross,
	faEdit,
	faMinusCircle,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { modalActions } from "../../constants";

export const DataTableRowButton = ({ actionData, onClick }) => {
	const { action, icon, buttonText } = actionData;
	const modalButtonText = buttonText || action;

	let defaultIcon;
	switch (action) {
		case modalActions.DELETE:
			defaultIcon = faMinusCircle;
			break;
		case modalActions.EDIT:
		default:
			defaultIcon = faEdit;
			break;
	}

	return (
		<Dropdown.Item
			key={action}
			onClick={(e) => {
				e.stopPropagation();
				onClick(e);
			}}
		>
			<FontAwesomeIcon icon={icon || defaultIcon} className="me-2" />
			{modalButtonText}
		</Dropdown.Item>
	);
};
